var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250.6 250.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,250.62c-2.1,0-4.14-.83-5.66-2.34-1.89-1.89-2.71-4.59-2.19-7.2l14.71-74.59c.31-1.56,1.07-2.99,2.19-4.11L149.56,29.86c1.5-1.5,3.54-2.34,5.66-2.34s4.16.84,5.66,2.34l59.88,59.88c3.12,3.12,3.12,8.19,0,11.31L88.25,233.56c-1.12,1.12-2.55,1.88-4.11,2.19l-74.59,14.71c-.51.1-1.03.15-1.55.15ZM30.09,171.96l-11.93,60.5,60.5-11.93,125.13-125.13-48.57-48.57L30.09,171.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.76,101.06l-11.31-11.31,21.95-21.95c4.3-4.3,4.3-11.29,0-15.59l-32.98-32.98c-2.08-2.08-4.85-3.23-7.79-3.23s-5.71,1.15-7.79,3.23l-21.95,21.95-11.31-11.31,21.95-21.95c5.1-5.1,11.89-7.91,19.11-7.91s14,2.81,19.11,7.92l32.98,32.98c10.53,10.54,10.53,27.68,0,38.21l-21.95,21.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.65,
    y: 155.62,
    width: 16,
    height: 84.69,
    transform: "translate(-124.56 95.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.02,
    y: 123.71,
    width: 109.77,
    height: 16,
    transform: "translate(-58.31 122.66) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.fbfc2f3c909a6892c3413b78a207bd11.svg";
export { ForwardRef as ReactComponent };